import { call, put, takeEvery } from 'redux-saga/effects'
import * as reportActions from '../ducks/reportDucks'
import * as reportApi from '../../api/reportApi'

interface FetchReportListSaga {
  type: string
  payload: string
}

function* fetchListReportDeptList({ payload: queryString }: FetchReportListSaga) {
  try {
    const res: ReturnType<typeof reportApi.getListReportDeptList> = yield call(reportApi.getListReportDeptList, queryString)
    yield put(reportActions.getListReportDeptListSuccess(res))
  } catch (error) {
    yield put(reportActions.getListReportDeptListFail(error))
  }
}

function* fetchListReportDeptDetail({ payload: queryString }: FetchReportListSaga) {
  try {
    const res: ReturnType<typeof reportApi.getListReportDeptDetail> = yield call(reportApi.getListReportDeptDetail, queryString)
    yield put(reportActions.getListReportDeptDetailSuccess(res))
  } catch (error) {
    yield put(reportActions.getListReportDeptDetailFail(error))
  }
}

export default function* watchOrder() {
  // báo cáo
  yield takeEvery(reportActions.getListReportDeptList.toString(), fetchListReportDeptList)
  yield takeEvery(reportActions.getListReportDeptDetail.toString(), fetchListReportDeptDetail)


}
